import { memo } from 'react';

import { AirIcon } from '@air/design-icons';
import { ModalCloseButton } from '@air/primitive-modal';

export const AirModalLogoHeader = memo(({ onClose }: AirModalProps) => (
  <div className="flex items-center justify-center">
    <AirIcon className="mt-[-18px] h-[80px] text-black dark:text-white" />
    <ModalCloseButton
      data-testid="AIR_MODAL_HEADER_CLOSE_BUTTON"
      className="absolute top-8 right-8 size-8 shrink-0"
      size="small"
      onClick={onClose}
    />
  </div>
));

AirModalLogoHeader.displayName = 'AirModalLogoHeader';
